import * as React from 'react';
import {forwardRef, Fragment, useEffect, useImperativeHandle, useState} from 'react';
import Formatter from '../../../util/formatter';
import {useTranslation} from 'react-i18next';
import useOpenState from '../../../hooks/useOpenState';
import {ColumnTypes} from './../hl7/hl7_messages_comp';
import ColumnsManager, {getColumns} from './../hl7/columns_manager';
import {useSelector} from 'react-redux';
import {agylePref} from '../../../store/reducers/preferences';
import _ from 'lodash';
import DocsTable from './docs_table';


const DocReports = forwardRef((props, ref) => {

    const {t} = useTranslation();
    const [isModalOpen, openModal, closeModal] = useOpenState(false, true);

    const [selectedRow, setSelectedRow] = React.useState(null);

    const [detailsModalIsVisible, setDetailsModalIsVisible] = useState(false);
    const [detailsMessage, setDetailsMessage] = useState(null);

    const openMessageDetails = (message) => {
        setDetailsMessage(message)
        setDetailsModalIsVisible(true);
    }
    const tableRef = React.useRef(null);
    useImperativeHandle(ref, () => ({
        exportCsv: () => {
            return tableRef.current.exportCsv();
        },
    }));
    const agylePreference = useSelector(agylePref);
    const [columns, setColumns] = React.useState([])

    useEffect(()=>{
        setColumns(getColumns(columnsInit, agylePreference?.inMessageColumnOrder));
    },[agylePreference, props.timeInUtc]);

    const openJsonModal = (row) => {
        if(row.message) {
            setSelectedRow(row)
            openModal();
        } else {

        }
    }


    const columnsInit = [
        // {
        //     name: 'id',
        //     order: 1,
        //     value: 'studyId',
        //     type: ColumnTypes.TEXT,
        //     description: 'Study Id',
        //     minWidth: 30
        // },
        {
            name: 'mrn',
            order: 1,
            value: 'catalog',
            type: ColumnTypes.TEXT,
            description: 'MRN No.',
            minWidth: 10,
            maxWidth: 175,
        },
        {
            name: 'docCount',
            order: 1,
            value: 'docCount',
            type: ColumnTypes.TEXT,
            description: 'Doc count',
            minWidth: 10,
            maxWidth: 175,
        },
        {
            name: 'date',
            order: 1,
            value: 'date',
            type: ColumnTypes.TEXT,
            description: 'Date',
            minWidth: 10,
            maxWidth: 175,
            sort: true,
            defaultSort: true,
            format: (value) => {
                return props.timeInUtc? Formatter.utcAndLocalFormatData(value,"YYYY-MM-DD HH:mm:ss",""): Formatter.LocalFormatData(value,"YYYY-MM-DD HH:mm:ss");
            }
        },
        // {
        //     name: 'publishDate',
        //     order: 1,
        //     value: 'publishDate',
        //     type: ColumnTypes.TEXT,
        //     description: 'PublishDate',
        //     minWidth: 10,
        //     maxWidth: 175,
        //     sort: true,
        //     defaultSort: true,
        //     format: (value) => {
        //         return props.timeInUtc? Formatter.utcAndLocalFormatData(value,"YYYY-MM-DD HH:mm:ss",""): Formatter.LocalFormatData(value,"YYYY-MM-DD HH:mm:ss");
        //     }
        // },
        // {
        //     name: 'admissionDate',
        //     order: 1,
        //     value: 'admissionDate',
        //     type: ColumnTypes.TEXT,
        //     description: 'AdmissionDate',
        //     minWidth: 10,
        //     maxWidth: 175,
        //     sort: true,
        //     defaultSort: true,
        //     format: (value) => {
        //         return props.timeInUtc? Formatter.utcAndLocalFormatData(value,"YYYY-MM-DD HH:mm:ss",""): Formatter.LocalFormatData(value,"YYYY-MM-DD HH:mm:ss");
        //     }
        // },
        // {
        //     name: 'admissionType',
        //     order: 1,
        //     value: 'AdmissionType',
        //     type: ColumnTypes.TEXT,
        //     description: 'admissionType',
        //     minWidth: 10,
        //     maxWidth: 175,
        // },
        // {
        //     name: 'specialty',
        //     order: 1,
        //     value: 'specialty',
        //     type: ColumnTypes.TEXT,
        //     description: 'Specialty',
        //     minWidth: 10,
        //     maxWidth: 175,
        // },
        // {
        //     name: 'uploaderName',
        //     order: 1,
        //     value: 'uploaderName',
        //     type: ColumnTypes.TEXT,
        //     description: 'Uploader Name',
        //     minWidth: 10,
        //     maxWidth: 175,
        // },
        {
            name: 'lastUpdate',
            order: 1,
            value: 'lastUpdate',
            type: ColumnTypes.TEXT,
            description: 'Last Update',
            minWidth: 10,
            maxWidth: 175,
            sort: true,
            format: (value) => {
                return props.timeInUtc? Formatter.utcAndLocalFormatData(value,"YYYY-MM-DD HH:mm:ss",""): Formatter.LocalFormatData(value,"YYYY-MM-DD HH:mm:ss");
            }
        },
        {
            name: 'location',
            order: 1,
            value: 'location',
            type: ColumnTypes.TEXT,
            description: 'Location',
            minWidth: 10,
            maxWidth: 175,
        },
        {
            name: 'patientName',
            order: 1,
            value: 'patientName',
            type: ColumnTypes.FUNC,
            description: 'Name',
            minWidth: 10,
            maxWidth: 175,
            valueFunc: (row) => {
                return (<Fragment>
                    <div>{row.patientFirstName} {row.patientFamilyName} {row.patientMiddleNames}</div>
                </Fragment>)
            },
            csvValueFunc: (row) => {
                return `${row.patientFirstName ? row.patientFirstName : ""} ${row.patientFamilyName ? row.patientFamilyName : ""} ${row.patientMiddleNames ? row.patientMiddleNames : ""}`;
            },
        },
        // {
        //     name: 'patientGender',
        //     order: 1,
        //     value: 'patientGender',
        //     type: ColumnTypes.TEXT,
        //     description: 'Gender',
        //     minWidth: 10,
        //     maxWidth: 175,
        // },
        {
            name: 'procedure',
            order: 1,
            value: 'procedure',
            type: ColumnTypes.TEXT,
            description: 'Procedure',
            minWidth: 10,
            maxWidth: 175,
        },
        {
            name: 'technician',
            order: 1,
            value: 'technician',
            type: ColumnTypes.TEXT,
            description: 'Operator',
            minWidth: 10,
            maxWidth: 175,
        },
        // {
        //     name: 'patientNationality',
        //     order: 1,
        //     value: 'patientNationality',
        //     type: ColumnTypes.TEXT,
        //     description: 'Nationality',
        //     minWidth: 10,
        //     maxWidth: 175,
        // },
        // {
        //     name: 'lastAccess',
        //     order: 1,
        //     value: 'lastaccess',
        //     type: ColumnTypes.TEXT,
        //     description: 'Last Access',
        //     minWidth: 10,
        //     maxWidth: 175,
        //     sort: true,
        //     format: (value) => {
        //         return props.timeInUtc? Formatter.utcAndLocalFormatData(value,"YYYY-MM-DD HH:mm:ss", ""): Formatter.LocalFormatData(value,"YYYY-MM-DD HH:mm:ss");
        //     }
        // },
        // {
        //     name: 'lastaccessedby',
        //     order: 1,
        //     value: 'lastaccessedby',
        //     type: ColumnTypes.TEXT,
        //     description: 'User Name',
        //     minWidth: 10,
        //     maxWidth: 175,
        // }

    ];




    const handleCloseMessageDetails = () =>{
        setDetailsModalIsVisible(false);
    }


    const getMessage = (row) => {
        return row.message
    }

    const sortColumn = () => {
        const filteredColumns = _.filter(columns, col => {
            return !_.isNil(col.order);
        });

        return _.sortBy(filteredColumns, obj => {
            return obj.order;
        });
    };


    const [openConfig, setOpenConfig] = React.useState(false);

    return (<div>

        {/*<IconButton*/}
        {/*    size={"small"}*/}
        {/*    disableRipple={true}*/}
        {/*    onClick={() => setOpenConfig(true)}>*/}
        {/*    <SettingsIcon/>*/}
        {/*</IconButton>*/}

        <ColumnsManager prefPath={"inMessageColumnOrder"}
                        columns = {columns}
                        title={"Incoming Messages Columns Settings"}
                        columnsInit = {columnsInit}
                        openConfig={openConfig}
                        closeModal={() => setOpenConfig(false)}/>

        <DocsTable ref={tableRef} table = {"hl7Log"} openColumnManager={() => setOpenConfig(true)} webSocketChanel = {"TODODocReports"} columns={sortColumn()} messagePath={getMessage} {...props}/>
    </div>);
})

export default DocReports;